import { Box, styled } from "@mui/material";

export const ChatListWrapper = styled(Box)({
  width: 320,
  borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  height: "100%",
  overflowY: "auto",
});
